module.exports = __webpack_public_path__ + "images/emoji/e-mail.4cc8e37f46363c55d79b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/e-mail.png
// module id = xOlR
// module chunks = 13